import { render, staticRenderFns } from "./BaseSearchInput.vue?vue&type=template&id=056c2b4a"
import script from "./BaseSearchInput.vue?vue&type=script&lang=ts"
export * from "./BaseSearchInput.vue?vue&type=script&lang=ts"
import style0 from "./BaseSearchInput.vue?vue&type=style&index=0&id=056c2b4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports